<template>
    <v-layout row wrap>
        <v-flex xs12 sm6 d-flex>
            <hzd-date-picker label="desde" v-model="fromDate" :min="min" :max="toDate"></hzd-date-picker>
        </v-flex>
        <v-flex xs12 sm6 d-flex>
            <hzd-date-picker label="hasta" v-model="toDate" :min="fromDate" :max="max"></hzd-date-picker>
        </v-flex>
    </v-layout>
</template>

<script>
import hzdDatePicker from "./DatePicker";

export default {
  props: {
    value: {
      type: Object,
      default: function() {
        return {
          fromDate: null,
          toDate: null
        };
      }
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
    }
  },
  data() {
    return {
      fromDate: this.value.fromDate || this.$moment().format("YYYY-MM-DD"),
      toDate: this.value.toDate || this.$moment().format("YYYY-MM-DD")
    };
  },
  components: {
    hzdDatePicker
  },
  methods: {
    dateChanged() {
      this.$emit("input", this.$data);
    }
  },
  watch: {
    fromDate() {
      this.dateChanged();
    },
    toDate() {
      this.dateChanged();
    }
  }
};
</script>
